import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class ItemParallax {
	constructor() {

		this.items 				= GSAP.utils.toArray('[data-speed]')
		this.createTriggers 	= this.createTriggers.bind(this)
		
		this.createTriggers()

	}

	createTriggers() {

		if( window.app.lenis !== null 
			&& this.items
			&& !window.app.isMobile
			&& !window.app.isTouch
		){

			this.items.forEach((item) => {

				if( item.dataset.speed !== 'auto' ){

					GSAP.to(item, {
						y: function() {return (1 - parseFloat(item.getAttribute("data-speed"))) * (ScrollTrigger.maxScroll(window) - (this.scrollTrigger ? this.scrollTrigger.start : 0))},
						ease: "none",
						scrollTrigger: {
							trigger: item.parentElement,
							start: "top top",
							end: "bottom top",
							invalidateOnRefresh: true,
							scrub: true
						}
					});
				
				}
				
			});

		}

	}

}
